import api from '@js/actions/api';

export const fetchAutocomplete = (autocompleteParams, requestOptions = {}) => (
    api
        .get('/api/v1/search/autocomplete', {
            search: autocompleteParams
        }, requestOptions)
);
